// import axios from "./axios";

// export async function addclinicalNote(
//   authContext,
//    note,
//   serviceId,
//   clinicalNoteType
// ) {
//   const NEW_NOTE_URL = "/api/clinicalNote";
//   var result = { isSuccess: false, data: {}, errorMessage: "" };
//   await axios
//     .post(
//       NEW_NOTE_URL,
//       {
//         availedServiceId: serviceId,
//         noteJson: JSON.stringify(note),
//         //status: prescription.status,
//         noteType: clinicalNoteType,
//       },

//       {
//         headers: {
//           Authorization: "Bearer " + authContext.authToken,
//           Accept: "application/json, text/plain, */*",
//           "Content-Type": "application/json",
//         },
//       }
//     )
//     .then(async function (response) {
//       result.isSuccess = true;
//       result.data = response?.data;
//     })
//     .catch(function (error) {
//       result.isSuccess = false;
//       result.data = error?.response?.data;
//     });
//   return result;
// }

// export async function updateClinicalNote(authContext, note, noteId) {
//     const UPDATE_NOTE_URL = `/api/clinicalNote/${noteId}`;
//     var result = { isSuccess: false, data: {}, errorMessage: "" };
    
//     await axios
//       .put(
//         UPDATE_NOTE_URL,
//         {
//             noteId: noteId,
//           noteJson: JSON.stringify(note),
//         },
//         {
//           headers: {
//             Authorization: "Bearer " + authContext.authToken,
//             Accept: "application/json, text/plain, */*",
//             "Content-Type": "application/json",
//           },
//         }
//       )
//       .then(async function (response) {
//         result.isSuccess = true;
//         result.data = response?.data;
//       })
//       .catch(function (error) {
//         result.isSuccess = false;
//         result.data = error?.response?.data;
//       });
//     return result;
//   }
  
//   export async function getClinicalNote(authContext, noteId) {
//     const GET_NOTE_URL = `/api/clinicalnote/${noteId}`;
//     var result = { isSuccess: false, data: {}, errorMessage: "" };
    
//     await axios
//       .get(
//         GET_NOTE_URL,
//         {
//           headers: {
//             Authorization: "Bearer " + authContext.authToken,
//             Accept: "application/json, text/plain, */*",
//           },
//         }
//       )
//       .then(async function (response) {
//         result.isSuccess = true;
//         result.data = response?.data;
//       })
//       .catch(function (error) {
//         result.isSuccess = false;
//         result.data = error?.response?.data;
//       });
//     return result;
//   }

//   export async function getClinicalNotesForService(authContext, serviceId) {
//     const GET_NOTE_URL = `/api/clinicalnote/service/${serviceId}`;
//     var result = { isSuccess: false, data: {}, errorMessage: "" };
    
//     await axios
//       .get(
//         GET_NOTE_URL,
//         {
//           headers: {
//             Authorization: "Bearer " + authContext.authToken,
//             Accept: "application/json, text/plain, */*",
//           },
//         }
//       )
//       .then(async function (response) {
//         result.isSuccess = true;
//         result.data = response?.data;
//       })
//       .catch(function (error) {
//         result.isSuccess = false;
//         result.data = error?.response?.data;
//       });
//     return result;
//   }
  
//   export async function deleteClinicalNote(authContext, noteId) {
//     const DELETE_NOTE_URL = `/api/clinicalNote/${noteId}`;
//     var result = { isSuccess: false, data: {}, errorMessage: "" };
    
//     await axios
//       .delete(
//         DELETE_NOTE_URL,
//         {
//           headers: {
//             Authorization: "Bearer " + authContext.authToken,
//             Accept: "application/json, text/plain, */*",
//           },
//         }
//       )
//       .then(async function (response) {
//         result.isSuccess = true;
//         result.data = response?.data;
//       })
//       .catch(function (error) {
//         result.isSuccess = false;
//         result.data = error?.response?.data;
//       });
//     return result;
//   }
import { apiRequest } from "./ApiUtility";

export async function addclinicalNote(authContext, note, serviceId, clinicalNoteType) {
  const url = "/api/clinicalNote";
  const data = {
    availedServiceId: serviceId,
    noteJson: JSON.stringify(note),
    noteType: clinicalNoteType,
  };
  return await apiRequest("post", url, authContext, data);
}

export async function updateClinicalNote(authContext, note, noteId) {
  const url = `/api/clinicalNote/${noteId}`;
  const data = {
    noteId: noteId,
    noteJson: JSON.stringify(note),
  };
  return await apiRequest("put", url, authContext, data);
}

export async function getClinicalNote(authContext, noteId) {
  const url = `/api/clinicalnote/${noteId}`;
  return await apiRequest("get", url, authContext);
}

export async function getClinicalNotesForService(authContext, serviceId) {
  const url = `/api/clinicalnote/service/${serviceId}`;
  return await apiRequest("get", url, authContext);
}

export async function deleteClinicalNote(authContext, noteId) {
  const url = `/api/clinicalNote/${noteId}`;
  return await apiRequest("delete", url, authContext);
}
